import { render, staticRenderFns } from "./GraduateCard.vue?vue&type=template&id=666f556a&scoped=true&"
import script from "./GraduateCard.vue?vue&type=script&lang=js&"
export * from "./GraduateCard.vue?vue&type=script&lang=js&"
import style0 from "./GraduateCard.vue?vue&type=style&index=0&id=666f556a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666f556a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WishList: require('/opt/buildhome/repo/components/graduates/WishList.vue').default})
